// src/contexts/roles.js
// Qué rutas ve cada rol y a dónde aterriza tras el login.

// Roles con acceso a las pantallas operativas (dashboard, asistencia a campo).
// Secretaría las ve igual que el viewer (vista@): solo lectura.
export const ROLES_OPERATIVOS = ["admin", "manager", "viewer", "secretaria", "basic"];

// Roles de solo lectura en asistencia a campo.
export const ROLES_SOLO_LECTURA = ["viewer", "secretaria"];

// Boletas firmadas: datos sensibles, solo administración y secretaría.
export const ROLES_BOLETAS = ["admin", "secretaria"];

export function homePathForRole(role) {
  return ROLES_OPERATIVOS.includes(role) ? "/dashboard" : "/boletas-firmadas";
}
